import { useState, useEffect } from "react";
import { loadDefaultParameterConfigById } from "../services/defaultparameterconfig";

const useDefaultParameterConfigById = (parameter) => {
    const [defaultParameterConfig, setDefaultParameterConfig] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [loading, setLoading] = useState(true);  // Add loading state here 


    const LoadParameterDetail = async (parameterId) => {
        try {

            const payload = {
                company_id: localStorage.getItem('companyid'),
                parameter_id: parameterId
            }
            const data = await loadDefaultParameterConfigById(payload);
            if (data) {
                setDefaultParameterConfig(data);
                setIsDataLoaded(true);
            }
        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false);  // Set loading to false after data is fetched
        }
    }

    useEffect(() => {
        if (!isDataLoaded && parameter > 0) {
            LoadParameterDetail(parameter);
        }
    })

    const getParemeterDetail = async (parameterId) => {
        await LoadParameterDetail(parameterId);
    }

    return { defaultParameterConfig, setDefaultParameterConfig, isDataLoaded, setIsDataLoaded, getParemeterDetail };
};

export default useDefaultParameterConfigById;